import { SignupFlowSlug } from "@./state";

export const signupSteps: { label: string; slugs: SignupFlowSlug[] }[] = [
  {
    label: "Cat info",
    slugs: [
      SignupFlowSlug.CAT_NAMES,
      SignupFlowSlug.BASIC_INFORMATION,
      SignupFlowSlug.AGE,
    ],
  },
  {
    label: "Food habits",
    slugs: [
      SignupFlowSlug.EATING_HABITS,
      SignupFlowSlug.MOTIVATION,
    ],
  },
  {
    label: "Lifestyle",
    slugs: [
      SignupFlowSlug.FITNESS,
      SignupFlowSlug.WEIGHT,
      SignupFlowSlug.CURRENT_DIET,
    ],
  },
  {
    label: "Health",
    slugs: [
      SignupFlowSlug.MEDICAL_CONDITIONS,
      SignupFlowSlug.ALLERGIES,
    ],
  },
];
